import { registryPageData as registryCatalogPageData } from '@data-ts/pages/registry';
export const registryPageData = {
  seoText: 'Landing page dedicated to Joy’s honeymoon and experiences registries | Joy',
  title: 'And remember,<br/>we’re always here for you.',
  content: 'Chat with the best customer service team in weddings —<br/>we’re here to make sure you get to the big day without the fray.',
  quote: 'I get paid to help people in love — it doesn’t get better than that!',
  caption: 'Jane Doe, Team Member since 2015',
  seo: {
    title: 'Zero-Fee Cash Wedding Registry | Wedding Cash Funds by Joy',
    content:
      'A cash registry with no fees for you or your guests. Create your cash fund now to save for your future, plus add honeymoon experiences and gift cards.',
  },
  getStarted: 'Get Started',
  learnMore: 'Learn More',
  hero: {
    title: 'Your zero-fee cash wedding registry',
    content: 'Save for your dreams faster with a zero-fee cash fund registry.',
  },
  noFeeCashEverWrapper: {
    title: 'Cash gifting is easier than ever.',
    body:
      'Integrations with your favorite cash sharing services allow your loved ones to skip the credit card fees and easily contribute to your cash fund via Venmo, PayPal, and CashApp with zero fees. ',
    fee2BlogText: 'Cash Registry',
  },
  chooseExperiencesSection: {
    eyebrow: 'Customize Your Cash Funds',
    title: 'Your dreams are just a cash fund away.',
    feature:
      'Create a general cash fund, such as for a dream honeymoon or house down payment, or customize cash funds for specific experiences like airfare. The gift options are limitless to save for your life together as newlyweds.',
    getExploreExperiences: 'Get Started',
  },
  publicCatalogSection: {
    eyebrow: 'The Joy Shop',
    title: 'Create Your Registry Wish List',
    feature:
      'Complement your cash funds with must-have registry items. Saving for a honeymoon? We’ve got your travel needs covered. Requesting contributions toward a home improvement project? You’ll need tools for that!',
    body: 'Shop by Department',
    departmentIconList: registryCatalogPageData.publicCatalogSection.departmentIconList,
    catlogList: [
      {
        image: 'cash-fund/shop-1.jpg',
        title: 'Away',
        body: 'The Bigger Carry-On',
        url: 'https://withjoy.com/shop/item/f3598c55-d1f2-5e9a-99a0-f5ec4aee4bad',
      },
      {
        image: 'cash-fund/shop-2.jpg',
        title: 'Airbnb',
        body: 'Airbnb Gift Card',
        url: 'https://withjoy.com/shop/item/36e71fb5-0ce2-5539-87a2-b14a16335c9f',
      },
      {
        image: 'cash-fund/shop-3.jpg',
        title: 'Lowe’s',
        body: 'Lowe’s Gift Card',
        url: 'https://withjoy.com/shop/item/310c9c09-eb10-51e1-8665-7a3432d2be8d ',
      },
      {
        image: 'cash-fund/shop-4.jpg',
        title: 'Grill',
        body: 'Performer Deluxe Charcoal Grill',
        url: 'https://withjoy.com/shop/item/cb9ddf90-f96c-5313-a180-76995576b238',
      },
      {
        image: 'cash-fund/shop-5.jpg',
        title: 'Vacuum',
        body: 'V10 Animal Cordless Stick Vacuum',
        url: 'https://withjoy.com/shop/item/a9c49ce3-db8d-558a-93e9-5b3e5fc3324e',
      },
      {
        image: 'cash-fund/shop-6.jpg',
        title: 'Duvet',
        body: 'Cloud Cotton 3-Piece Duvet Cover Set in Ivory, Full/Queen',
        url: 'https://withjoy.com/shop/item/3543ac1f-5b5e-5216-b241-bfd628c9c825',
      },
    ],
    exploreShopButton: {
      label: 'Explore the Shop',
      url: 'https://www.withjoy.com/shop',
    },
  },
  linkedRegistrySection: {
    eyebrow: 'We Love All Registries',
    title: 'Sync and link any registry.',
    body: 'Already registered? No problem. Connect any registry and allow your guests to shop in one easy place.',
  },
  charityRegistrySection: {
    eyebrow: 'Charity Donations',
    title: 'Gifts that</br>keep on giving.',
    body: 'Support your favorite causes, right from your wedding registry.',
  },
  oneRegistrySection: {
    eyebrow: 'One Link For All Your Guests',
    title: 'Better for your guests means better for you.',
    body: 'Make it easy for your guests to give you the perfect gift, with everything you want right on your wedding website.',
  },
  registryApp: {
    eyebrow: 'Shop on Your Phone',
    title: 'Add items from wherever, whenever.',
    body: 'Shop from any store, manage your registry, even track who has purchased what, right on your phone.',
    download: 'Download',
    joy: 'Joy for iOS or Android',
    altTextAppStore: 'app store',
    altTextGooglePlay: 'google play',
  },
  registryBrandsSection: {
    eyebrow: 'Shop ‘Til You Drop',
    title: 'Your favorite brands, together at last.',
    body: 'Ask for exactly what you want — from flatware to gift cards — all in one place.',
  },
  registryCrossSection: {
    eyebrow: 'The Best Part',
    title: 'Your wedding registry comes with Joy.',
    body:
      'From a beautiful wedding website and matching invites, to powerful wedding planning tools and our always-here-for-you customer support team, we’ve built the smarter way to plan your big day.',
    featuresData: [
      {
        image: 'honeymoon-fund/icon-website-v2.svg',
        title: 'Free Wedding</br>Websites',
      },
      {
        image: 'honeymoon-fund/icon-cards-v2.svg',
        title: 'Save the Dates, Invites & Matching Prints',
      },
      {
        image: 'honeymoon-fund/icon-wand-v2.svg',
        title: 'Powerful</br>Planning Tools',
      },
      {
        image: 'honeymoon-fund/icon-support-v2.svg',
        title: 'Personal</br>Customer Support',
      },
    ],
  },
  registryJoyButtonSection: {
    eyebrow: 'The Joy Browser Button',
    title: 'Add gifts from any website, literally.',
    body:
      'Shop anywhere with the Joy Browser Button. Add items from top brands, your favorite Etsy store, or the little shop around the corner, with a click of a button.',
  },
  universalRegistrySection: {
    eyeBrow: 'Your Universal Registry',
    title: 'Ask for everything you want, in one place.',
    content:
      'Add cash and honeymoon funds, experiences, physical gifts, gift cards, and more to your All-in-One Registry, giving your wedding guests one convenient place to shop.',
    madeItEasier: 'We’ve made it better to give <em>and</em> receive.',
    registryItemImageAlt: 'Registry item',
    registryTypeGifts: 'Gifts',
    registryTypeCash: 'Cash Funds',
    registryTypeExperiences: 'Experiences',
    registryTypeCharity: 'Charity',
    UniversalRegistryText: 'Less time guest listing, more time bucket listing.',
  },
  emotionalBreak: {
    title: 'Designed to let you focus on what matters.',
    altText: 'Image of couple dancing in an aquarium',
  },
  sections: {
    faqList: {
      title: 'Still have questions?',
    },
    stats: {
      title: 'We’ve helped millions celebrate love around the world.',
      subtitle: 'That’s more cake, flowers and happy tears than we can count.',
      data: [
        {
          title: 'million',
          body: 'The largest guest list in Joy',
          endingNumber: 8,
          incrementFrequency: 150,
        },
        {
          title: 'countries',
          body: 'Screaming babies have interrupted weddings on',
          endingNumber: 86,
          incrementFrequency: 100,
        },
        {
          title: 'guests',
          body: 'People around the world',
          endingNumber: 768,
          incrementFrequency: 20,
        },
      ],
    },
  },
} as const;
